import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import "./UserList.css";

const VoicesList = () => {
    document.title = "Voices | Uma Classes";

    const [voices, setVoices] = useState([]);
    const [modal, setModal] = useState(false);
    const [voiceIdToDelete, setVoiceIdToDelete] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchVoices = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('https://uma.aasmo.in/api/admin/getall-voices', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setVoices(response || []); // Adjusted to access data property
            } catch (error) {
                console.error('Error fetching voices:', error);
            }
        };

        fetchVoices();
    }, []);

    const toggleModal = () => setModal(!modal);

    const handleDelete = (voiceId) => {
        setVoiceIdToDelete(voiceId);
        toggleModal();
    };

    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`https://uma.aasmo.in/api/admin/delete-voices/${voiceIdToDelete}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setVoices(voices.filter(voice => voice._id !== voiceIdToDelete));
            toggleModal();
        } catch (error) {
            console.error('Error deleting voice:', error);
        }
    };

    const handleEdit = (voiceId) => {
        navigate(`/edit-voices/${voiceId}`);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Voices" breadcrumbItem="All" />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title">All Voices</h4>
                                    <p className="card-title-desc">Below are all voices</p>

                                    <div className="table-responsive">
                                        <table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Title</th>
                                                    <th>Category</th>
                                                    <th>Upload Date</th>
                                                    <th>Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {voices.length > 0 ? (
                                                    voices.map((voice, index) => (
                                                        <tr key={voice._id}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td className="nowrap">{voice?.title}</td>
                                                            <td className="nowrap">{voice?.category?.name || "N/A"}</td>
                                                            <td className="nowrap">{moment(voice?.createdAt).format('MMMM Do, YYYY')}</td>
                                                            <td>
                                                                <i className="dripicons-document-edit" onClick={() => handleEdit(voice._id)} />{" "}
                                                                <i className="dripicons-document-delete" onClick={() => handleDelete(voice._id)} />{" "}
                                                                <Link to={voice?.voiceUrl}>
                                                                    <i className="dripicons-cloud-download" />
                                                                </Link>
                                                            </td>

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">No voices found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* Delete Confirmation Modal */}
                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete this voice?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                        <Button color="danger" onClick={confirmDelete}>Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default VoicesList;
